/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Youtube_Export_Privacy_PublicInputs */

const cs_youtube_export_privacy_public = /** @type {(inputs: Youtube_Export_Privacy_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veřejné`)
};

const en_youtube_export_privacy_public = /** @type {(inputs: Youtube_Export_Privacy_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public`)
};

/**
* | output |
* | --- |
* | "Public" |
*
* @param {Youtube_Export_Privacy_PublicInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const youtube_export_privacy_public = /** @type {((inputs?: Youtube_Export_Privacy_PublicInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Youtube_Export_Privacy_PublicInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_youtube_export_privacy_public(inputs)
	return cs_youtube_export_privacy_public(inputs)
});